/**
 * Averages over the selected period, for the needles of the gauges.
 *
 * Both needles are weighted by DEAANTA, the number of pigs: a delivery of 15
 * pigs counts three times as much as one of 5, and a busy BPG week more than a
 * quiet one. The BPG average only covers the weeks the page shows, i.e. the
 * weeks the supplier delivered in - the webservice sends no others.
 */

/**
 * The pig-weighted average of one field over the rows. A row without a value
 * or without pigs cannot be weighed and is left out. Null when nothing is left.
 */
export const weightedAverage = (rows, field) => {
  let total = 0;
  let pigs = 0;
  rows.forEach(row => {
    const value = row[field];
    const count = row.DEAANTA;
    if (value === null || value === undefined || !(count > 0)) {
      return;
    }
    total += value * count;
    pigs += count;
  });
  return pigs > 0 ? total / pigs : null;
};

const averagesPerField = (rows, fields) =>
  fields.reduce(
    (averages, field) => ({ ...averages, [field]: weightedAverage(rows, field) }),
    {}
  );

/** Red needle: the supplier's deliveries over the period. */
export const deliveryAverages = (weeks, fields) =>
  averagesPerField(
    weeks.flatMap(week => week.deliveries),
    fields
  );

/** Black needle: the BPG week averages over the period. */
export const bpgAverages = (weeks, fields) =>
  averagesPerField(
    weeks.map(week => week.average).filter(Boolean),
    fields
  );
